import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Profile from "./component/Registration/Profile";
import RegisterProfile from "./component/Registration/RegisterProfile";
import EditProfile from "./component/Registration/EditProfile";
import Home from "./component/Home";
import Contact from "./component/Contact/Contact";
import Login from "./component/Login/Login";
import ForgotPassword from "./component/Login/ForgotPassword";
import Notifications from "./component/Notifications";
import MySchedule from "./component/MySchedule";
import ChargingActivity from "./component/ChargingActivity";
import FavouritePlaces from "./component/FavouritePlaces";
import PaymentHistory from "./component/PaymentHistory";
import ChargeHistory from "./component/ChargeHistory";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import FourOhFour from "./component/Shared/FourOhFour";
import NewDriverPlan from "./component/PlanSelection/New";
import DriverPlans from "./component/PlanSelection";
import Help from "./component/Help";
import About from "./component/About";
import {
  apiEndpointFailed,
  displayToast,
  appOnlineOfflineMode,
} from "./actions/commonActions";
import ApiErrorModal from "./component/UI/ApiErrorModal";
import ChargingSitesHeader from "./component/Shared/ChargingSitesHeader";
import { Toast, Row, Col } from "react-bootstrap";

require("dotenv").config();

function App() {
  const dispatch = useDispatch();
  const {
    apiEndPointFailed,
    showToast,
    appOnlineOfflineModeDisplay,
  } = useSelector((reduxState) => reduxState.common);
  const [modalStatus, setModalStatus] = useState({
    title: null,
    isApiEndPointFailed: "",
    message: "",
  });

  // shows toast of app offline when browser is offline
  useEffect(() => {
    if (!navigator.onLine) {
      appOnlineOfflineMode(dispatch, false);
    }
  }, []);

  useEffect(() => {
    setModalStatus({
      title: apiEndPointFailed.title,
      isApiEndPointFailed: apiEndPointFailed.isApiEndPointFailed,
      message: apiEndPointFailed.bodyMessage,
    });
  }, [apiEndPointFailed]);

  const modalHideHandler = () => {
    setModalStatus(!modalStatus);
    let responseObject = {
      errorStatusCode: null,
      message: "",
      error: "",
    };
    apiEndpointFailed(dispatch, false, responseObject);
  };

  return (
    <Router>
      <ChargingSitesHeader />
      <Switch>
        <Route path="/notifications" component={Notifications} />
        <Route path="/profile/:id/edit" component={EditProfile} />
        <Route path="/profile/:id" component={Profile} />
        <Route path="/charging_activity" component={ChargingActivity} />
        <Route path="/favourite_places" component={FavouritePlaces} />
        <Route path="/payment_history" component={PaymentHistory} />
        <Route path="/charge_history" component={ChargeHistory} />
        <Route path="/contact" component={Contact} />
        <Route path="/home" component={Home} />
        <Route path="/my_schedule" component={MySchedule} />
        <Route path="/help" component={Help} />
        <Route path="/about" component={About} />
        <Route path="/plan_selection" component={NewDriverPlan} />
        <Route path="/driver_plans" component={DriverPlans} />
        <Route path="/register-profile" component={RegisterProfile} />
        <Route path="/" exact component={Login} />
        <Route path="/forgot_password" exact component={ForgotPassword} />
        <Route component={FourOhFour} />
      </Switch>
      {modalStatus.isApiEndPointFailed && (
        <ApiErrorModal
          apiErrorInfo={modalStatus}
          modalHideHandler={modalHideHandler}
        />
      )}
      {/* <Row className="notification-toast">
        <Col xs={12} className="ml-2">
          <Toast show={!appOnlineOfflineModeDisplay}>
            <Toast.Header>
              <strong className="mr-auto">
                {" "}
                {!appOnlineOfflineModeDisplay ? "App offline" : ""}
              </strong>
            </Toast.Header>
          </Toast>
        </Col>
      </Row> */}
      <Row className="notification-toast">
        <Col xs={12} className="ml-2 toast-col">
          <Toast
            onClose={() => displayToast(dispatch, { text: "", display: false })}
            show={showToast.display == true}
            delay={3000}
            autohide
          >
            <Toast.Header>
              <text className="mr-auto">{showToast.text}</text>
            </Toast.Header>
          </Toast>
        </Col>
      </Row>
    </Router>
  );
}

export default App;
